import client from "./client";
import { metaClickIds } from "../lib/metaClickIds";

// Both session creators send Meta's click ids along with the request. They
// land in the Checkout Session's metadata, which is how the Stripe webhook —
// a request with no browser behind it — can still report the sale to Meta.
// This is what covers the buyer who taps "Buy it now" without ever leaving an
// email: no lead row exists for them, so the metadata is the only copy.
// Read here rather than by each caller so no button can forget them.
function clickIds() {
  const { fbc, fbp } = metaClickIds();
  return { fbc: fbc || null, fbp: fbp || null };
}

export const checkoutApi = {
  createSession: (couponCode) =>
    client.post("/api/checkout/create-session", {
      coupon_code: couponCode || null,
      ...clickIds(),
    }),

  // No account, no session: Stripe collects the address and the webhook
  // provisions the account from the paid session. See
  // backend/services/stripe_service.create_guest_checkout_session.
  createGuestSession: (couponCode) =>
    client.post("/api/checkout/guest-session", {
      coupon_code: couponCode || null,
      ...clickIds(),
    }),
};
